export const isSamplesOrderLocationCartState = (state) => {
    if (!state || typeof state !== 'object')
        return false;
    return 'cart' in state;
};
